/**
 * Hook that reads the `is_admin` claim from the current JWT access token.
 * Returns `true` only when the token contains `is_admin === true`.
 *
 * This mirrors the pattern in AdminPresencePage but exposes it as a
 * reusable hook for any admin-gated route.
 */
import { getAccessToken } from "../api";

function decodeJwtPayload(token: string): Record<string, unknown> | null {
  try {
    const parts = token.split(".");
    if (parts.length !== 3) return null;
    const base64 = parts[1].replace(/-/g, "+").replace(/_/g, "/");
    const json = atob(base64);
    return JSON.parse(json) as Record<string, unknown>;
  } catch {
    return null;
  }
}

export function useIsAdmin(): boolean {
  const token = getAccessToken();
  if (!token) return false;
  const payload = decodeJwtPayload(token);
  return payload?.is_admin === true;
}
